module.exports = __webpack_public_path__ + "static/media/westin-copley-place.0edfb7e1.jpg";